const theme = {
    // Smartphones Mobiles (Portrait)
    mqMobile: `@media (min-width: 320px) and (max-width: 480px)`,
    // Smartphones Mobiles (Landscape)
    mqMobileHorz: `@media (min-width: 481px) and (max-width: 767px)`,
    // Tablets, Ipads (Portrait)
    mqTablets: `@media all (min-width: 768px) and (max-width: 1024px)`,
    // Tablets, Ipads (Landscape)
    mqTabletsHorz: `@media all (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)`,
    // Desktops
    mqSmallDesktops: `@media (min-width: 1025px)`,
    mqMediumDesktops: `@media (min-width: 1281px)`,
    mqLargeDesktops: `@media (min-width: 1600px)`,
    mqXLargeDesktops: `@media (min-width: 1920px)`,

    lineClamp: (lineNumber)=>{
        return `
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: ${lineNumber};
            overflow: hidden;
        `;
    },
    
    visuallyHidden: ()=>{
        return `
          position: absolute !important;
          clip: rect(1px 1px 1px 1px);
          clip: rect(1px, 1px, 1px, 1px);
          padding:0 !important;
          border:0 !important;
          height: 1px !important;
          width: 1px !important;
          overflow: hidden;
        `;
    },

    // Main colors
    $color_1: `#FFF`,
    $color_2: `#E1E5E6`,
    $color_3: `#0000003D`,
    $color_4: '#D32F2F',
    $color_5: '#F2F2F2',
    $color_6: '#D9DCE1',
    $color_7: '#9A9B9B',
    $color_8: '#54C341',
    $color_9: '#777D85',
    $color_10: '#C62828',
    $color_11: '#000',
    $color_12: '#EFF2F3',
    $color_13: '#2A9B1A',
    $color_14: '#c5b8b9',
    $color_15: '#C2C2C2',
    $color_16: '#565656',
    $color_17: '#DEDEDE',
    $color_18: `#FABD21`,
    $color_19: `rgba(0, 0, 0, 0.87)`,
    $color_20: `00CFFF`,
    $color_21: `#83D984`,
    $color_22: `#E3E3E3`,
    $color_23: `#242FFF`,
    $color_24: `#FFFFFF`,
    $color_25: `#FBA59F`,
    $color_26: `#CE0006`,

    $fontFamily: `'Source Sans Pro', sans-serif`,
    $fwRegular: 400,
    $fwMedium: 500,
    $fwSemibold: 600,
    $fwBold: 700
};

theme['$fontFamily'] = theme['$fontFamily'];
theme['$fwRegular'] = theme['$fwRegular'];
theme['$fwMedium'] = theme['$fwMedium'];
theme['$fwSemibold'] = theme['$fwSemibold'];
theme['$fwBold'] = theme['$fwBold'];

//account
theme['$accountTopPanelBgColor'] = theme['$color_1'];
theme['$accountTopPanelBtnBgColor'] = theme['$color_10'];
theme['$accountTopPanelBtnTextColor'] = theme['$color_1'];
theme['$accountTopPanelSeparatorColor'] = theme['$color_10'];
theme['$accountUserActivityLinkColor'] = theme['$color_10'];

//account session history
theme['$accountSessionHistoryTopBgColor'] = theme['$color_1'];
theme['$accountSessionHistoryTimerNumbersColor'] = theme['$color_10'];
theme['$accountSessionHistoryListBgColor'] = theme['$color_12'];

//account menu
theme['$accountMenuColor'] = theme['$color_11'];
theme['$accountMenuItemBg'] = theme['$color_1'];


//edit profile
theme['$accountProfileColor'] = theme['$color_11'];
theme['$accountProfileBackground'] = theme['$color_1'];
theme['$accountProfileRowBorderColor'] = theme['$color_2'];
theme['$accountProfileTextColor'] = theme['$color_3'];
theme['$accountProfileErrorTextColor'] = theme['$color_4'];
theme['$accountProfileUploadDocumentButtonBackground'] = theme['$color_4'];
theme['$accountProfileUploadedDocumentButtonBackground'] = theme['$color_8'];
theme['$accountProfileSubmitButtonBackground'] = theme['$color_4'];
theme['$accountProfileSubmitButtonColor'] = theme['$color_1'];
theme['$accountProfileUpdateModalMessage'] = theme['$color_9'];

//account cashback
theme['$accountProfileCashbackButtonBg'] = theme['$color_10']; 
theme['$accountProfileCashbackFilterButtonBg'] = theme['$color_1'];
theme['$accountProfileCashbackFilterButtonBgActive'] = theme['$color_4']; 
theme['$accountProfileCashbackButtonColor'] = theme['$color_11']; 
theme['$accountProfileCashbackButtonColorActive'] = theme['$color_1'];
theme['$accountProfileCashbackWithdrawBg'] = theme['$color_1'];
theme['$accountProfileCashbackAmount'] = theme['$color_4'];

//register form
theme['$registerFormBackgroundColor'] = theme['$color_1'];
theme['$registerFormLabelColor'] = theme['$color_11'];
theme['$registerFormLabelBgColor'] = theme['$color_1'];
theme['$registerFormLinkColor'] = theme['$color_4'];
theme['$registerFormInputBackgroundColor'] = theme['$color_1'];
theme['$registerFormInputColor'] = theme['$color_11'];
theme['$registerFormSubmitButtonBgColor'] = theme['$color_10'];
theme['$registerFormSubmitButtonColor'] = theme['$color_1'];
theme['$registerFormInputBorderColor'] = theme['$color_3'];
theme['$registerFormPreviousButtonBgColor'] = theme['$color_1'];
theme['$registerFormPreviousButtonColor'] = theme['$color_7'];
theme['$registerFormStepBgColor'] = theme['$color_1'];
theme['$registerFormStepActiveBgColor'] = theme['$color_4'];
theme['$registerFormConfirmationCloseBtnBgColor'] = theme['$color_10'];

//payments
theme['$paymentsBackground'] = '#F2F2F2';
theme['$paymentsBorderColor'] = theme['$color_2'];
theme['$paymentsTextColor'] = theme['$color_3'];
theme['$paymentsErrorTextColor'] = theme['$color_4'];
theme['$paymentsSubmitButtonBackground'] = theme['$color_4'];
theme['$paymentsSubmitButtonColor'] = theme['$color_1'];
theme['$paymentsSubmitDisabledBackground'] = '#EAEAEA';
theme['$paymentsSubmitDisabledColor'] = '#000000';

// forgotPassword
theme['$forgotPasswordInputBorderColor'] = theme['$color_3'];
theme['$forgotPasswordButtonBgColor'] = theme['$color_10'];
theme['$forgotPasswordLabelBgColor'] = theme['$color_1'];

// bonus
theme['$accountProfileBonusTabActiveBonusProgressBarMainColor'] = theme['$color_10'];
theme['$accountProfileBonusTabActiveBonusProgressBarBgColor'] = theme['$color_1'];
theme['$accountProfileBonusTabActiveBonusProgressBarPercColor'] = theme['$color_11'];
theme['$accountProfileBonusTabActiveBonusProgressBarMainColor'] = theme['$color_10']; 
theme['$accountProfileBonusTabActiveBonusCancelBg'] = theme['$color_10'];
theme['$accountProfileBonusTabActiveBonusProgressBarPercDarkColor'] = theme['$color_1'];
theme['$accountProfileBonusTabActiveBonusCanceledIcon'] = theme['$color_4']; 
theme['$accountProfileBonusTabActiveBonusCheckIconBg'] = theme['$color_13']; 
theme['$accountProfileBonusTabActiveBonusCheckIconSign'] = theme['$color_1']; 
theme['$accountProfileBonusTabActiveHeaderBorder'] = theme['$color_10'];
theme['$accountProfileBonusTabActiveBonusRowBg'] = theme['$color_1'];
theme['$accountProfileBonusTabActiveHeaderBg'] = theme['$color_12'];
theme['$accountProfileBonusTabActiveHeaderTxt'] = theme['$color_11'];
theme['$accountProfileBonusModalsCancelBttnBg'] = theme['$color_10'];
theme['$accountProfileBonusModalsSuccessBttnBg'] = theme['$color_1'];

theme['$accountProfileBonusModalsAcceptBorderBttnBg'] = theme['$color_10'];
theme['$accountProfileBonusModalsAcceptBttnColor'] = theme['$color_10'];
theme['$accountProfileBonusModalsTextColor'] = theme['$color_11'];

// account bet history 
theme['$accountProfileBetHistoryDatesBackground'] = theme['$color_1']; 
theme['$accountProfileBetHistoryDatepickerBorder'] = theme['$color_15']; 
theme['$accountProfileBetHistoryDatepickerLabelBg'] = theme['$color_1']; 
theme['$accountProfileBetHistoryFilterBttnTxt'] = theme['$color_11']; 
theme['$accountProfileBetHistoryStatusFiltersBackground'] = theme['$color_1'];
theme['$accountProfileBetHistoryFilterBttnActive'] = theme['$color_4']; 
theme['$accountProfileBetHistoryFilterBttnActiveTxt'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTransactionHeaderTxtColor'] = theme['$color_11']; 
theme['$accountProfileBetHistoryTransactionHeaderBorder'] = theme['$color_4']; 
theme['$accountProfileBetHistoryTransactionLabelBg'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTransactionLostLabelColor'] = theme['$color_10']; 
theme['$accountProfileBetHistoryTransactionWonLabelColor'] = theme['$color_13']; 
theme['$accountProfileBetHistoryTransactionDetailsHeaderBgActions'] = theme['$color_10']; 
theme['$accountProfileBetHistoryTransactionDetailsHeaderBgInfo'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTransactionDetailsHeaderTitle'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTransactionDetailsMainColor'] = theme['$color_11']; 
theme['$accountProfileBetHistoryTransactionDetailsBg'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTransactionDetailsHeaderBlockBg'] = theme['$color_10']; 
theme['$accountProfileBetHistoryTransactionDetailsHeaderBlockTxt'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTransactionDetailsFooterTxt'] = theme['$color_11'];  
theme['$accountProfileBetHistoryTransactionDetailsRebetBackground'] = theme['$color_1']; 
theme['$accountProfileBetHistoryCashoutBttnBackground'] = theme['$color_13']; 
theme['$accountProfileBetHistoryCashoutBttnColor'] = theme['$color_1']; 
theme['$accountProfileBetHistoryTvBetBorderColor'] = theme['$color_1'];
theme['$accountProfileBetHistoryTvBetIconColor'] = theme['$color_1'];
theme['$accountProfileBetHistoryTvBetActiveBackgroundColor'] = theme['$color_18'];
theme['$accountProfileBetHistoryTvBetTextColor'] = theme['$color_19'];
theme['$accountProfileBetHistoryTvBetPlacedTypeColor'] = theme['$color_20'];       
theme['$accountProfileBetHistoryTvBetInfoSecionSeparator'] = theme['$color_12'];

//profile cashback
theme['$accountProfileCashbackButtonBg'] = theme['$color_62']; 
theme['$accountProfileCashbackButtonColor'] = theme['$color_25']; 
theme['$accountProfileCashbackWithdrawBg'] = theme['$color_25'];
theme['$accountProfileCashbackEvenRowBg'] = theme['$color_78'];

//cashout modal
theme['$accountProfileBetHistoryCashoutHeader'] = theme['$color_27']; 

//profile bet history share
theme['$accountProfileBetHistoryShareLinkInfoSuccessBackground'] = theme['$color_13'];
theme['$accountProfileBetHistoryShareLinkInfoSuccessColor'] = theme['$color_1']; 


// wallet
theme['$accountWalletRadioButtonBorder'] = theme['$color_4'];

// datepicker
theme['$datepickerLabelColor'] = theme['$color_16'];
theme['$datepickerLabelBg'] = theme['$color_1'];
theme['$datepickerInputBg'] = theme['$color_1'];
theme['$datepickerInputColor'] = theme['$color_16'];


// favourites
theme['$favouritesHeaderBackground'] = theme['$color_17'];
theme['$favouritesHeaderColor'] = theme['$color_11'];

// register by myID
theme['$formBackgroundColor'] = theme['$color_24']
theme['$inputColor'] = theme['$color_15'];
theme['$inputActiveColor'] = theme['$color_11']
theme['$inputErrorColor'] = theme['$color_4'];
theme['$inputLabelColor'] = theme['$color_21'];
theme['$inputPlaceholderColor'] = theme['$color_15'];
theme['$inputBackgroundColor'] = theme['$color_24'];
theme['$submitButtonTextColor'] = theme['$color_24'];
theme['$headerTextColor'] = theme['$color_11'];
theme['$footerTextColor'] = theme['$color_11'];
theme['$resendTextColor'] = theme['$color_11'];
theme['$resendButtonColor'] = theme['$color_23']
theme['$methodBorderColor'] = theme['$color_15'];
theme['$methodBackgroundColor'] = theme['$color_24']
theme['$methodTextColor'] = theme['$color_11'];
theme['$checkedCheckboxColor'] = theme['$color_11'];
theme['$checkboxBorderColor'] = theme['$color_15'];
theme['$checkboxBackgroundColor'] = theme['$color_24'];
theme['$labelTextColor'] = theme['$color_11'];
theme['$dropdownArrowColor'] = theme['$color_22'];
theme['$infoBorderColor'] = theme['$color_11'];
theme['$submissionErrorColor'] = theme['$color_26'];
theme['$submissionErrorBackgroundColor'] = theme['$color_25'];
theme['$stepperPrimaryColor'] = theme['$color_15'];
theme['$stepperAccentColor'] = theme['$color_4'];
theme['$stepperBackgroundColor'] = theme['$color_24'];
theme['$stepperTextColor'] = theme['$color_24'];

export default theme;